(() => {
  if (customElements.get('mf-weight-details')) return;
  class WeightDetails extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.output = this.querySelector('[data-result]');
      this.scope = this.closest('.shopify-section') || document;
      this.update();
      this.timer = setInterval(() => this.update(),500);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      const input = this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
      const id = input ? input.value : new URLSearchParams(location.search).get('variant') || this.config.initial;
      if (this.previous === id) return;
      this.previous = id;
      const variant = this.config.variants.find(v => String(v.id) === String(id));
      if (!variant) { this.output.textContent = this.config.text.select; return; }
      const engine = globalThis.MFWeightEngine;
      const profile = engine.profileFor(this.config.handle,this.config.tags || []);
      const resolved=engine.resolveVariant(variant,profile);
      const g=resolved.dimensions, estimate=resolved.estimate, productLb=resolved.pounds;
      this.dataset.variantId = String(id);
      this.dataset.productLb = productLb === null ? '' : String(productLb);
      this.dataset.method = profile ? profile.method : 'catalog';
      const t=this.config.text;
      const pounds = value => `${value.toLocaleString()} lb`;
      if (this.getAttribute('mode') === 'summary') {
        this.output.textContent = productLb ? `${t.product}: ${pounds(productLb)}${estimate ? ' · '+t.estimate : ''}` : t.missing;
        return;
      }
      if (!g || !productLb) { this.output.textContent = !productLb ? t.missing : t.review; return; }
      const s=engine.shipment(g,productLb,profile && profile.method==='sculpture');
      const rows = [[t.productSize,`${g.l}″ × ${g.w}″ × ${g.h}″`],[t.product,pounds(s.product)],[t.packedSize,`${s.l}″ × ${s.w}″ × ${s.h}″`],[t.pallet,pounds(s.pallet)],[t.packing,pounds(s.packing)],[t.total,pounds(s.gross)]];
      const fragment=document.createDocumentFragment();
      const title=document.createElement('strong');title.textContent=t.heading;fragment.append(title);
      const dl=document.createElement('dl');dl.style.margin='0';
      for(const [label,value] of rows) {
        const dt=document.createElement('dt');dt.style.marginTop='10px';dt.textContent=label;
        const dd=document.createElement('dd');dd.style.margin='0';dd.style.fontWeight='600';dd.textContent=value;
        dl.append(dt,dd);
      }
      fragment.append(dl);
      const note=document.createElement('p');note.style.fontSize='.9em';
      const method=profile ? t[profile.method] : t.catalog;
      note.textContent=`${method}. ${estimate ? t.fabrication : t.catalog} ${t.disclaimer}${s.packingReview ? ' '+t.sculptureReview : ''}`;
      fragment.append(note);this.output.replaceChildren(fragment);
    }
  }
  customElements.define('mf-weight-details',WeightDetails);
})();
